import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-currency-ex-rate-hist',
  templateUrl: './currency-ex-rate-hist.component.html',
  styleUrls: ['./currency-ex-rate-hist.component.css']
})
export class CurrencyExRateHistComponent implements OnInit {
    currencyExRateKeyno;

    public itemsListHistory: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.currencyExRateKeyno = this.stateService.getStateParams()['currencyexrate_keyno'];
    }

    private async loadHistory(): Promise<void> {
        this.itemsListHistory = await this.datatask.Post(1025, { currencyexrate_keyno: this.currencyExRateKeyno });
    }

    private async init() {
        this.loadHistory();
    }

    ngOnInit() {
        this.init();
    }
}
